/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforgueststitle3Inputs */

const en_goodforgueststitle3 = /** @type {(inputs: Goodforgueststitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What guests say`)
};

const de_goodforgueststitle3 = /** @type {(inputs: Goodforgueststitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was Gäste sagen`)
};

/**
* | output |
* | --- |
* | "What guests say" |
*
* @param {Goodforgueststitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforgueststitle3 = /** @type {((inputs?: Goodforgueststitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforgueststitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforgueststitle3(inputs)
	return de_goodforgueststitle3(inputs)
});
export { goodforgueststitle3 as "goodForGuestsTitle" }